import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loader", "LoadingComponent"];
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import LoadingScreen from 'pricing-pages-ui-components/components/LoadingScreen';
function makeLoadable(_ref) {
  let {
      loader,
      LoadingComponent
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Loadable(Object.assign({
    loader,
    LoadingComponent
  }, rest));
}
export const PublicMarketingHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-marketing-hub-page" */'./marketing/PublicMarketingHubPage'),
  LoadingComponent: LoadingScreen
});
export const PublicSalesHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-sales-hub-page" */'./sales/PublicSalesHubPage'),
  LoadingComponent: LoadingScreen
});
export const PublicServiceHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-service-hub-page" */'./service/PublicServiceHubPage'),
  LoadingComponent: LoadingScreen
});
export const PublicContentHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-content-hub-page" */'./content/PublicContentHubPage'),
  LoadingComponent: LoadingScreen
});
export const PublicDataHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-data-hub-page" */'./data/PublicDataHubPage'),
  LoadingComponent: LoadingScreen
});
export const PublicCommerceHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-commerce-hub-page" */'./commerce/PublicCommerceHubPage'),
  LoadingComponent: LoadingScreen
});
export const PublicFreeToolsPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-free-tools-page" */'./free/PublicFreeToolsPage'),
  LoadingComponent: LoadingScreen
});
export const PublicPlatformPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-suite-page" */'./suite/PublicPlatformPage'),
  LoadingComponent: LoadingScreen
});
export const PublicSmartCrmPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-smart-crm-page" */'./smart-crm/PublicSmartCrmPage'),
  LoadingComponent: LoadingScreen
});
export const PublicMarketingPlusPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-marketing-plus-page" */'./marketing-plus/PublicMarketingPlusPage'),
  LoadingComponent: LoadingScreen
});